import React from 'react';
import './App.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { BrowserRouter } from 'react-router-dom';
import { Routes } from './routes';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './shared/css/theme';
import { Snackbar } from './shared/components/snackbar/Snackbar';
import { client } from './shared/apollo';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider } from './modules/auth/AuthProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_API_KEY } from './shared/constants';


export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ApolloProvider client={client}>
        <GoogleOAuthProvider clientId={GOOGLE_API_KEY as string}>
          <AuthProvider>
            <ThemeProvider theme={theme}>
              <Snackbar />
              <Routes />
            </ThemeProvider>
          </AuthProvider>
        </GoogleOAuthProvider>
      </ApolloProvider>
    </BrowserRouter>
  );
};
